import React, { useContext, useEffect, useState } from 'react';
import Select from "react-select";
import { Icon } from '@iconify/react';
import { ToastContainer, toast } from 'react-toastify'
import { AddSessionApi, CalendarOfSittingsAdd, GetConstituency, GetKlaListForSearchFilter, GetMemberList, GetMemberMappingList, GetRole, GetSalutation, MemberMappinAdd, SittingsListBasedOnSession, SubmitSittingsEdit } from '../../Services/allApi';
import DatePicker from 'react-datepicker';

function EditSittings({handleCloseModalSS,detailsTable}) {
    const [currentStep, setCurrentStep] = useState(1);
    const [completedSteps, setCompletedSteps] = useState([]);
    const [videoDetailsArray, setVideoDetailsArray] = useState([]);
    const [sessionList, setSessionList] = useState([])
    const [klaList, setKlaList] = useState([])
    const [memberList, setMemberList] = useState([])
    const [constituencyList, setconstituencyList] = useState([])
    const [saluationtList, setSaluationtList] = useState([])
    const [roleList, setRoleList] = useState([])

    const [inputType,setinputType]=useState('text')
    const [VideoInitialDetails, setVideoInitialDetails] = useState({
        startDate: null,
        endDate: null,
        kla: null,
        video_session: null,
    });

    const [SessionIdAfterConnected,setSessionIdAfterConnected]=useState('')


    // sittings logic starts
    const [currentEntry, setCurrentEntry] = useState({
        sitting_date: null,
        description: '',
        malayalam_description:'',
        id:''
    });

    const [entryList, setEntryList] = useState([]);

    const handleInputChangeSittings = (field, value) => {
        setCurrentEntry({
            ...currentEntry,
            [field]: value
        });
    };

    const handleAddEntry = () => {
        if(currentEntry.sitting_date&&currentEntry.description){
        setEntryList([currentEntry,...entryList]);
        setCurrentEntry({
            sitting_date: currentEntry.sitting_date,
            description: '',
            malayalam_description:''
        });}
        
        else{
            toast.warning("Fill the from completely to add")
        }
    };

    const handleInputChangeListSittings = (index, field, value) => {
        const newEntryList = [...entryList];
        newEntryList[index][field] = value;
        setEntryList(newEntryList);
    };

    const handleRemoveEntry = (index) => {
        const newEntryList = entryList.filter((_, i) => i !== index);
        setEntryList(newEntryList);
    };

    const handleSubmit = async() => {
        const token=sessionStorage.getItem('access_token')
        const reqHeader = {
         "Content-Type": "application/json",
         "Authorization": `${token}`
     };
        console.log(entryList);

        // const modifiedSittingsList = entryList?.map(item => ({
        //     sitting_date: item.sitting_date,
        //     description:item.description,
        //     malayalam_description:item?.malayalam_description??item?.malayalam_description,
        //     id:item.id
        //     // session: SessionIdAfterConnected
        // }));
        const modifiedSittingsList = entryList?.map(item => {
            const modifiedItem = {
                id: item.id,
                sitting_date: item.sitting_date,
                description: item.description,
            };

            if (item?.malayalam_description) {
                modifiedItem.malayalam_description = item.malayalam_description;
            }

            return modifiedItem;
        });
        
        const curentSession=detailsTable?.session_id
        
        console.log(JSON.stringify(modifiedSittingsList, null, 2));

        const res= await SubmitSittingsEdit(modifiedSittingsList,reqHeader,curentSession)
        // console.log(res);
        if(res.status==200){
            handleCloseModalSS()
            alert("Sittings edited successfully")
        }
        else{
            alert(res?.response?.data?.message??"There was problem!!!")
        }
    };
    // siitng logic ends

    useEffect(()=>{
        SittingsList()
    },[])

    const SittingsList=async()=>{
        const token=sessionStorage.getItem('access_token')
        const reqHeader = {
         "Content-Type": "application/json",
         "Authorization": `${token}`
     };
        const curentSession=detailsTable?.session_id
        // console.log(entryList);
        const res=await SittingsListBasedOnSession({session_id:curentSession},reqHeader)
        setEntryList(res?.data?.data)
    }

    // const addSittingsBulk=()=>{
    //     for(var i=1;i<=100;i++){
    //         const data={sitting_date:`202${i}-08-16`,description:"desc"+i,id:"",malayalam_description:"desc_mal"+i}
    //         callApiToAdd(data)
    //     }
    // }
    // const callApiToAdd=async(data)=>{
    //     const token=sessionStorage.getItem('access_token')
    //     const reqHeader = {
    //      "Content-Type": "application/json",
    //      "Authorization": `${token}`
    //  };
    //     const res= await SubmitSittingsEdit(data,reqHeader,5)    }
    return (
        <>
            <div className='flex flex-row w-full h-full' style={{ height: '86vh' }}>
                
                    <div className='flex flex-col items-center w-full overflow-x-hidden overflow-y-scroll' style={{ height: '87vh' }}>
                    <div className='flex items-start justify-end w-full pb-1'><div onClick={handleCloseModalSS} className='flex items-center justify-center h-8 text-red-500 duration-500 ease-in-out transform border border-red-500 rounded cursor-pointer w-14 hover:bg-red-500 hover:text-white'><Icon icon="iconamoon:close" className='text-2xl' /></div></div>

                        <div className='flex flex-row flex-wrap justify-center w-full gap-1 ms-5 me-5 '>
                            <div className='flex flex-col w-full gap-5'>
                                <div className='px-4 py-2 border rounded bg-success'>
                                    <h3 className='mb-4 text-xl font-bold text-center text-blue-700'>Add Sittings</h3>
                                    {/* <button onClick={addSittingsBulk}>activate script</button> */}

                                    <div className='flex flex-row flex-wrap justify-center gap-5 mb-5'>
                                        <div className='flex flex-col w-3/12 '>
                                            <label htmlFor="sdate">Start Date</label>
                                            <input
                                            type='date'
                                                placeholderText="Start Date"
                                                selected={currentEntry.sitting_date}
                                                onChange={(e) => handleInputChangeSittings('sitting_date', e.target.value)}
                                                className='w-full h-10 px-2 border border-gray-700 rounded-lg'
                                                isClearable
                                            />
                                        </div>

                                        <div className='flex flex-col w-3/12'>
                                            <label>Description</label>
                                            <input
                                                type="text"
                                                value={currentEntry.description}
                                                onChange={(e) => handleInputChangeSittings('description', e.target.value)}
                                                className='w-full h-10 rounded-lg dateinput'
                                                style={{ border: '1px solid #384D6C' }}
                                            />
                                        </div>
                                        <div className='flex flex-col w-3/12'>
                                            <label>Description malayalam</label>
                                            <input
                                                type="text"
                                                value={currentEntry.malayalam_description}
                                                onChange={(e) => handleInputChangeSittings('malayalam_description', e.target.value)}
                                                className='w-full h-10 rounded-lg dateinput'
                                                style={{ border: '1px solid #384D6C' }}
                                            />
                                        </div>

                                        <div className='flex flex-col w-2/12 ms-5'>
                                            <label style={{ visibility: 'hidden' }}>Add</label>
                                            <button className='w-full py-2 mb-3 text-white bg-green-500 rounded-lg' onClick={handleAddEntry}>
                                                Add
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='flex flex-col w-full gap-4 mt-4'>
                            {entryList?.map((entry, index) => (
                                <div key={index} className='px-4 py-2 bg-gray-200 border rounded'>
                                    <h3 className='text-sm text-left text-gray-700'>No {index + 1}</h3>

                                    <div className='flex flex-row flex-wrap justify-center gap-5 mb-1'>
                                        <div className='flex flex-col w-3/12 '>
                                            <label>Start Date</label>
                                            <input
                                                type='date'
                                                value={entry.sitting_date}
                                                onChange={(e) => handleInputChangeListSittings(index, 'sitting_date', e.target.value)}
                                                className='w-full h-10 px-2 border border-gray-700 rounded-lg' 
                                                
                                            />
                                        </div>

                                        <div className='flex flex-col w-3/12'>
                                            <label>Description</label>
                                            <input
                                                type="text"
                                                value={entry.description}
                                                onChange={(e) => handleInputChangeListSittings(index, 'description', e.target.value)}
                                                className='w-full h-10 rounded-lg dateinput'
                                                style={{ border: '1px solid #384D6C' }}
                                            />
                                        </div>

                                        <div className='flex flex-col w-3/12'>
                                            <label>Description malayalam</label>
                                            <input
                                                type="text"
                                                value={entry.malayalam_description}
                                                onChange={(e) => handleInputChangeListSittings(index, 'malayalam_description', e.target.value)}
                                                className='w-full h-10 rounded-lg dateinput'
                                                style={{ border: '1px solid #384D6C' }}
                                            />
                                        </div>

                                        <div className='flex flex-col w-2/12 ms-5'>
                                            <label style={{ visibility: 'hidden' }}>Remove</label>
                                            <button className='w-full py-2 mb-3 text-white bg-red-500 rounded-lg' onClick={() => handleRemoveEntry(index)}>
                                                Remove
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        
                            <div className='flex flex-row justify-center gap-5 w-full'>
                                <div className='w-2/12'>
                                <button className='w-full py-2 mt-20 text-white rounded-full bg-primary' onClick={handleSubmit}>
                                    Submit
                                </button>
                            </div>

                            <div className='w-2/12'>
                                <button className='w-full py-2 mt-20 text-red-500 border rounded-full bg-success' onClick={handleCloseModalSS}>
                                    Cancel
                                </button>
                            </div>
                            </div>
                    
                    </div>
                

            </div>

            <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        draggable
        pauseOnHover
        theme="light"
      />
        </>
    );
}

export default EditSittings;
